module.exports = __webpack_public_path__ + "static/media/logo55.388420b3.png";